import { FormikValues } from 'formik'
import { datatype, lorem } from 'faker'

type Index = {
  tenor: string
  value: number
}

interface MarketIndexTenant {
  id: number
  name: string
  domain: string
  issuerId: number
  segmentCode: string
}

export interface MarketIndex {
  id: number
  name: string
  baseDate: string
  isBenchmark: boolean
  type: string
  tenant: MarketIndexTenant
  indexes: Array<Index>
}

export interface MarketIndexTableItem {
  id: number
  name: string
  baseDate: string
  isBenchmark: boolean
  type: string
  tenantId: number
  tenantName: string
  tenantDomain: string
  '1M'?: number
  '3M'?: number
  '6M'?: number
  '12M'?: number
  YTD?: number
}

export interface MarketIndexFormValues extends FormikValues {
  name: string
  baseDate: Date
  isBenchmark: boolean
  tenantId?: number
  '1M': number
  '3M': number
  '6M': number
  '12M': number
  YTD: number
}

export const buildMarketTableSource = ({ indexes, tenant, ...baseColumns }: MarketIndex): MarketIndexTableItem => {
  const indexesRaw = indexes.reduce((result, { tenor, value }) => ({ ...result, [tenor]: value }), {})

  return { ...baseColumns, ...indexesRaw, tenantId: tenant?.id, tenantName: tenant?.name, tenantDomain: tenant?.domain }
}

export const mockMarketIndexFormValues = (): MarketIndexFormValues => ({
  id: datatype.number(),
  name: lorem.word(),
  baseDate: datatype.datetime(),
  isBenchmark: datatype.boolean(),
  tenantId: datatype.number(),
  '1M': datatype.float({ min: 0, max: 10, precision: 4 }),
  '3M': datatype.float({ min: 0, max: 10, precision: 4 }),
  '6M': datatype.float({ min: 0, max: 10, precision: 4 }),
  '12M': datatype.float({ min: 0, max: 10, precision: 4 }),
  YTD: datatype.float({ min: 0, max: 10, precision: 4 }),
})

export const mockMarketIndexTableSource = (): MarketIndexTableItem => ({
  id: datatype.number(),
  name: lorem.word(),
  baseDate: datatype.datetime().toISOString(),
  isBenchmark: datatype.boolean(),
  type: lorem.word(),
  tenantId: datatype.number(),
  tenantName: lorem.word(),
  tenantDomain: lorem.word(),
  '1M': datatype.float({ min: 0, max: 10, precision: 4 }),
  '3M': datatype.float({ min: 0, max: 10, precision: 4 }),
  '6M': datatype.float({ min: 0, max: 10, precision: 4 }),
  '12M': datatype.float({ min: 0, max: 10, precision: 4 }),
  YTD: datatype.float({ min: 0, max: 10, precision: 4 }),
})

export const marketIndexTypes = [
  { label: 'Performance Reports', value: 'performance' },
  { label: 'BBSW', value: 'bbsw' },
]
